import React from 'react';
import PropTypes from 'prop-types';

import onClickOutside from 'react-onclickoutside';

import graphUtils from '../../../global/utils/graphUtils';
import TrashIcon from '../../../global/components/graph/TrashIcon.js.jsx';

import transitionStyles from '../transitionModuleStyles.css';

class GraphTransition extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSelected: false
      , trashIconX: null
      , trashIconY: null
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextState.isSelected !== this.state.isSelected
      || nextProps.startNodeSelected !== this.props.startNodeSelected
      || nextProps.endNodeSelected !== this.props.endNodeSelected
      || nextProps.draggingNode.id && nextProps.draggingNode.id === nextProps.transition._startNode
      || nextProps.draggingNode.id && nextProps.draggingNode.id === nextProps.transition._endNode
      // || nextProps.deletingNode !== this.props.deletingNode // update transitions if a node was deleted
      // || nextProps.selectedNodeId && nextProps.selectedNodeId === nextProps.transition._startNode
      // || nextProps.selectedNodeId && nextProps.selectedNodeId === nextProps.transition._endNode
    )
  }

  handleClick(e) {
    // set isSelected
    // console.log("screenX", e.screenX)
    // console.log("screenX", e.screenY)
    // console.log("clientX", e.clientX)
    // console.log("clientY", e.clientY)
    // console.log("this.props.graphMouseX", this.props.graphMouseX)
    // console.log("this.props.graphMouseY", this.props.graphMouseY)
    this.setState({
      isSelected: true
      // , trashIconX: e.screenX
      // , trashIconY: e.screenY
      , trashIconX: this.props.graphMouseX // move this
      , trashIconY: this.props.graphMouseY
    })
  }

  handleClickOutside(e) {
    // set unselected
    if(this.state.isSelected) {
      this.setState({
        isSelected: false
      })
    }
  }

  handleRemove(e) {
    this.props.onRemove(this.props.transition);
  }

	render() {
    const {
      draggingNode
      , endNode
      , endNodeSelected
      , onRemove
      , selectedNodeId
      , startNode
      , startNodeSelected
      , transition
    } = this.props;
    const { isSelected, trashIconX, trashIconY } = this.state;

    let startX;
    let startY;
    if(draggingNode.id && draggingNode.id === transition._startNode) {
      startX = draggingNode.x;
      startY = draggingNode.y;
    } else if(startNode) {
      startX = startNode.authoring.x;
      startY = startNode.authoring.y;
    }

    let endX;
    let endY;
    if(draggingNode.id && draggingNode.id === transition._endNode) {
      endX = draggingNode.x;
      endY = draggingNode.y;
    } else if(endNode) {
      endX = endNode.authoring.x;
      endY = endNode.authoring.y;
    }

    const isEmpty = (
      !startX
      || !startY
      || !endX
      || !endY
      || !transition
    )

    let pathString;
    let pathEndMarker;

    if(!isEmpty) {
      pathString = graphUtils.getTransitionPath(startX, startY, endX, endY)
      pathEndMarker = graphUtils.getTransitionMarker(startX, startY, endX, endY)
    }

    const strokeColor = isSelected ? "black"          : endNodeSelected ? "purple"           : startNodeSelected ? "teal"               : "darkgray"; // visualzzzzz
    const arrowRef =    isSelected ? "arrow-selected" : endNodeSelected ? "arrow-toSelected" : startNodeSelected ? "arrow-fromSelected" : "arrow-default"; // annoying. these are defined in the top level SVG in ContentModuleGraph

    const transitionStyles = {
      // fill:'rgba(0,0,0,0.5)'
      fill: 'none'
      , stroke: strokeColor
      , strokeWidth:'4'
      // , boxShadow: '6px 6px 28px -2px rgba(0,0,0,0.75)'
      // , filter: 'drop-shadow( -5px -5px 5px #000 )'
    }
    const transitionPointerStyles = {
      fill: 'none'
      , stroke: strokeColor
      , strokeWidth: '4'
      // , boxShadow: '6px 6px 28px -2px rgba(0,0,0,0.75)'
      // , filter: 'drop-shadow( -5px -5px 5px #000 )'
    }

    if(isEmpty) {
      return null;
    } else {
      // console.log('render transtition')
      return (
        <g onClick={(e) => {this.handleClick(e)}} className="-transition-arrow">
          <path markerEnd={`url(#${arrowRef})`} style={transitionPointerStyles} d={pathEndMarker} />

          <path style={transitionStyles} d={pathString}  />
          { isSelected ?
            <TrashIcon
              x={trashIconX}
              y={trashIconY}
              onClick={(e) => {this.handleRemove(e)}}
            />
            :
            null
          }
        </g>
      )
    }
	}
}

GraphTransition.propTypes = {
  deletingNode: PropTypes.bool
  , draggingNode: PropTypes.object
  , endNode: PropTypes.object
  , graphMouseX: PropTypes.number
  , graphMouseY: PropTypes.number
  , onRemove: PropTypes.func
  , selectedNodeId: PropTypes.string
  , startNode: PropTypes.object
  , transition: PropTypes.object.isRequired
}

GraphTransition.defaultProps = {
  deletingNode: false
  , draggingNode: {}
  , endNode: null
  , graphMouseX: null
  , graphMouseY: null
  , onRemove: null
  , selectedNodeId: ''
  , startNode: null
}

export default onClickOutside(GraphTransition);



// WEBPACK FOOTER //
// modules/transition/components/GraphTransition.js.jsx